import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'smartScreen',
    component: () => import('../views/smartScreen.vue')
  },
  {
    path: '/dorm',
    name: 'dormScreen',
    component: () => import('../views/dormScreen.vue')
  },
  {
    path: '/dormRealTime',
    name: 'dormRealTime',
    component: () => import('../views/dormRealTime.vue')
  },
  {
    path: '/screenDorm',
    name: 'screenDorm',
    component: () => import('../views/screenDorm.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
